import { http } from '../../axios';
import { productlistConfig } from '../../../config';
import { Pagination } from '../../../../models/Pagination';
import { MarketingCampaignResponseOut, ProductFilter } from '../../../store/api';

interface CampaignParams {
    ageCategory: string | null;
    loanFormat?: string | null;
    pagination: Pagination;
    filterMap: ProductFilter;
}

export const fetchYourCampaignProducts = async (props: CampaignParams) => {
    const { ageCategory, loanFormat, pagination, filterMap } = props;
    const endpointOpts = {
        ageCategory: ageCategory ? ageCategory : undefined,
        loanFormat: loanFormat ? loanFormat : undefined,

        pathParams: {
            kind: 'products'
        }
    };
    const params = { ...pagination, ageCategory: endpointOpts.ageCategory, loanFormat: endpointOpts.loanFormat };
    return http.post<MarketingCampaignResponseOut>(productlistConfig().endpointMarketingCampaign, filterMap, {
        params,
        pathParams: endpointOpts.pathParams
    });
};
